import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * No app iOS a assinatura da Klinvia não é paga nem gerenciada (regra 3.1 da
 * App Store): no lugar das opções de pagamento fica só este aviso.
 */
const NativeAppBillingNotice: React.FC<{ tone?: 'light' | 'dark' }> = ({ tone = 'light' }) => {
  const dark = tone === 'dark';
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: dark ? 'rgba(148,163,184,0.06)' : '#F8FAFC',
        border: '1px solid',
        borderColor: dark ? 'rgba(148,163,184,0.12)' : 'rgba(15,23,42,0.08)',
      }}
    >
      <Typography variant="body2" sx={{ color: dark ? '#E2E8F0' : 'text.primary', lineHeight: 1.6 }}>
        A assinatura da Klinvia desta clínica tem uma pendência. O responsável pela clínica deve tratar o
        assunto diretamente com a Klinvia. Depois de regularizado, o acesso é liberado automaticamente.
      </Typography>
    </Box>
  );
};

export default NativeAppBillingNotice;
